import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8a5cf8bc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=8a5cf8bc&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=8a5cf8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5cf8bc",
  null
  
)

export default component.exports